import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20products%20on%20textured%20concrete%20surface%2C%20sneakers%20hoodies%20bags%20watches%20and%20accessories%20arranged%20in%20organized%20systematic%20grid%20pattern%2C%20top-down%20birds%20eye%20view%2C%20bright%20professional%20studio%20lighting%2C%20systematic%20product%20categorization%20aesthetic%2C%20clean%20modern%20editorial%20catalog&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
        alt="Hipobuy Spreadsheet fashion product collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="Hipobuy Spreadsheet product collection"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <span className="text-white/70 text-xs md:text-sm font-medium tracking-[0.2em] uppercase mb-4">
          Updated Spreadsheet Resources
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight max-w-4xl">
          The Ultimate Resource for{' '}
          <span className="text-accent-300">Hipobuy Spreadsheet</span>
        </h1>
        <p className="mt-5 text-sm md:text-base text-white/75 max-w-2xl leading-relaxed">
          Find, compare and organize thousands of products faster with the latest Hipobuy Spreadsheet guides,
          category databases and expert shopping resources.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-white/90 text-foreground-900 font-semibold text-sm hover:bg-white transition-all duration-200 cursor-pointer"
          >
            Buy It Now
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 cursor-pointer"
          >
            Hipobuy Sheet
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl">
          {['Updated Spreadsheet Resources', 'Product Research Guides', 'Category Based Database', 'Safe Shopping Education'].map((badge) => (
            <span
              key={badge}
              className="text-xs text-white/60 flex items-center gap-1.5 justify-center"
            >
              <i className="ri-check-line text-accent-300 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>

      <a
        href="#categories"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer"
      >
        <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
      </a>
    </section>
  );
}